import { tw } from "src/design-system/tw";
import { DatesHotelSearchBar } from "src/domain/HotelsScreen/HotelSearch/Experiment/DatesHotelSearchBar";
import HotelLargeSearchBar from "src/domain/HotelsScreen/HotelSearch/HotelLargeSearchBar";
import { DatesSearchBar } from "src/domain/LargeSearchBar/DatesExperiment/DatesSearchBar";
import { LargeSearchBar } from "src/domain/LargeSearchBar/LargeSearchBar";
import { LazyTripSearchBar } from "src/domain/TripPlanner/TripSearchBar/LazyTripSearchBar";
import { useFeature } from "src/feature/useFeature";
import type { TabKind } from "src/utils/hooks/useTabKind";

type GlobalSearchProps = {
  className?: string;
  screenKind: TabKind;
};
export function GlobalSearch({
  className,
  screenKind,
}: Readonly<GlobalSearchProps>) {
  const isDatesSearchBar = useFeature("DatesSearchBar") !== "Baseline";
  const SearchBar = {
    transport: isDatesSearchBar ? DatesSearchBar : LargeSearchBar,
    trips: LazyTripSearchBar,
    hotels: isDatesSearchBar ? DatesHotelSearchBar : HotelLargeSearchBar,
  }[screenKind];

  return (
    <div
      role="search"
      className={tw(
        "flex max-w-full flex-1 rounded-full empty:hidden",
        !isDatesSearchBar && "bg-neutral-700",
        className,
      )}
    >
      <SearchBar />
    </div>
  );
}
